import React, { useState, useRef } from "react";
import styled from "styled-components";
import { RowElement, RowLayoutStyle } from "../../Sliders/AddSlide";
import { InputField1 } from "../../../InputField1/InputField1";
import Button from "../../../Button/Button";
import SeoProduct from "../../Products/newProducts/SeoProduct";
import { errorMessage } from "../../../../utils/message";
import {
  useAddNewCategory,
  useGetProductList1,
  useGetProductList2,
} from "../../../../hooks/useContent";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../Typography/Typography";
import { RefreshTableLevel3 } from "../../../../shared/content-unit";
import { useRecoilState } from "recoil";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";
import Editor from "../../../../core/components/textEditor/Editor";

function CatGeneratorLevel3() {
  const [refreshEffect, setRefreshEffect] = useRecoilState(RefreshTableLevel3);
  const inputFileRefMenu = useRef();
  const inputFileRefAikon = useRef();
  const inputSelect = useRef();
  const inputSelect2 = useRef();

  const {
    mutateAsync: addNewCategory,
    isLoading: reqLoading,
    error: reqError,
  } = useAddNewCategory();

  const { data, refetch, isLoading, error } = useGetProductList1("");

  const {
    data: productList2,
    refetch: refetchList,
    isLoading: isloadingProduct2,
    error: errorTow,
  } = useGetProductList2("", "");

  let selectOptions = data?.data?.categories?.map((cat) => {
    return { value: cat.IdCategories, label: cat.NameCategories };
  });

  const [selectOption2, setSelectOption2] = useState([]);
  const [defaultPlaceHolder, setDefaultHolder] = useState(
    "سطح 2 را انتخاب کنید"
  );

  const defaultOption = useState({
    value: -1,
    label: "کشور والد را انتخاب کنید",
  });

  const [parentId, setParentId] = useState(-1);

  const [newCategory, setNewCategory] = useState({
    name: "",
    en_name: "",
    ar_name: "",
    darkIcon: "",
    lightIcon: "",
    slug: "",
    en_slug: "",
    ar_slug: "",
    desc: "",
    aikenCategories: "",
    level: "2",
  });

  const [description, setDescription] = useState("");

  const isValidImg = (event) => {
    let isValid = true;

    const file = event.target.files[0];
    if (
      (file.type !== "image/png" &&
        file.type !== "image/jpg" &&
        file.type !== "image/jpeg") ||
      file.size > 0.8e6
    ) {
      file.size > 0.8e6
        ? errorMessage("فایل انتخاب شده بیشتر از 800 مگ است")
        : errorMessage("فایل انتخاب شده صحیح نیست");
      isValid = false;
      event.target.value = "";
    }
    return isValid;
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    if (e.target?.type === "file") {
      const file = e.target.files[0];
      if (isValidImg(e)) {
        setNewCategory({ ...newCategory, [name]: file });
      } else setNewCategory({ ...newCategory, [name]: "" });
      return 3;
    }

    setNewCategory({
      ...newCategory,
      [name]: value,
    });
  };

  const validateForm = () => {
    if (newCategory.name.length < 1) {
      errorMessage("لطفا نام فارسی دسته بندی را وارد کنید");
      return false;
    }

    // else if (newCategory.aikenCategories.length < 1) {
    //   errorMessage("لطفا عکس دسته بندی را وارد کنید");
    //   return false;
    // }
    else if (parentId === -1) {
      errorMessage("لطفا سطح دسته بندی 2 را انتخاب کنید");
      return false;
    } else if (newCategory.slug.length < 1) {
      errorMessage("لطفا لینک فارسی را وارد نمایید");
      return false;
    } else if (newCategory.en_slug.length < 1) {
      errorMessage("لطفا لینک انگلیسی را وارد کنید");
      return false;
    } else if (newCategory.ar_slug.length < 1) {
      errorMessage("لطفا لینک عربی را وارد کنید");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const formData = new FormData();
      formData.append("name", newCategory.name);
      formData.append("en_name", newCategory.en_name);
      formData.append("ar_name", newCategory.ar_name);
      formData.append("darkIcon", newCategory.darkIcon);
      formData.append("lightIcon", newCategory.lightIcon);
      formData.append("desc", newCategory.desc);
      formData.append("aikenCategories", newCategory.aikenCategories);
      formData.append("level", newCategory.level);
      formData.append("parent_id", parentId);
      formData.append("slug", newCategory.slug.replaceAll(" ", "-"));
      formData.append("en_slug", newCategory.en_slug.replaceAll(" ", "-"));
      formData.append("ar_slug", newCategory.ar_slug.replaceAll(" ", "-"));

      addNewCategory(formData).then((res) => {
        setRefreshEffect(!refreshEffect);
        setNewCategory({
          name: "",
          en_name: "",
          ar_name: "",
          darkIcon: "",
          lightIcon: "",
          productLabel: "",
          desc: "",
          slug: "",
          en_slug: "",
          ar_slug: "",
          aikenCategories: "",
          level: "2",
        });
        setDescription("");

        setParentId(-1);
        inputFileRefMenu.current.value = "";
        inputSelect.current.value = defaultOption[0]?.label;
      });
    }
  };

  const handleChangeSelectMode = (e) => {
    const { value } = e ?? -1;
    setParentId(value);
  };

  const handleChangeLevel1 = (e) => {
    const { value } = e ?? -1;
    setParentId(-1);

    setDefaultHolder("سطح 2 را  انتخاب کنید ");

    const filterData = productList2?.pages[0]?.data?.CategoriesLevelTwo?.filter(
      (cat) => cat?.parent?.IdCategories === value
    );

    setSelectOption2(
      filterData?.map((cat) => {
        return { value: cat.IdCategories, label: cat.NameCategories };
      })
    );
  };

  return (
    <LevelGeneratorStyle>
      <GeneratorWrapper>
        <RowDiv>
          <RowElement>
            <SimpleSelect1
              inputRef={inputSelect}
              label={"سطح 1 دسته بندی"}
              onChange={handleChangeLevel1}
              value={"سطح 1 را انتخاب کنید"}
              res={selectOptions}
            />
          </RowElement>
          <RowElement>
            <SimpleSelect1
              inputRef={inputSelect2}
              label={"سطح 2 دسته بندی"}
              onChange={handleChangeSelectMode}
              value={selectOption2[0]?.label}
              res={selectOption2}
            />
          </RowElement>
        </RowDiv>
        <RowDiv>
          <RowElement>
            <InputField1
              type="text"
              name="name"
              label="نام فارسی"
              onChange={handleChange}
              value={newCategory?.name}
              placeholder="نام فارسی دسته بندی.."
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="en_name"
              label="نام انگلیسی"
              onChange={handleChange}
              value={newCategory?.en_name}
              placeholder="نام انگلیسی دسته بندی..."
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="ar_name"
              label="نام عربی"
              onChange={handleChange}
              value={newCategory?.ar_name}
              placeholder="نام دسته بندی عربی ..."
              maxLenght="50"
            />
          </RowElement>
        </RowDiv>
        <RowDiv>
          <RowElement>
            <InputField1
              type="text"
              name="slug"
              label="url فارسی"
              onChange={handleChange}
              value={newCategory?.slug}
              placeholder="url فارسی.."
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="en_slug"
              label="url انگلیسی"
              onChange={handleChange}
              value={newCategory?.en_slug}
              placeholder="url انگلیسی.."
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="ar_slug"
              label="url  عربی"
              onChange={handleChange}
              value={newCategory?.ar_slug}
              placeholder="url عربی..."
              maxLenght="50"
            />
          </RowElement>
        </RowDiv>
        <RowDiv>
          <RowElement>
            <InputField1
              type="text"
              name="darkIcon"
              label="ایکن مشکی"
              onChange={handleChange}
              value={newCategory?.darkIcon}
              placeholder="ایکن مشکی"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="lightIcon"
              label="ایکن رنگی"
              onChange={handleChange}
              value={newCategory?.lightIcon}
              placeholder="ایکن رنگی"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="file"
              refInput={inputFileRefMenu}
              name="aikenCategories"
              label="در صورتی که اپلیکیشن اندروید یا iOS دارید، انتخاب فایل png تصویر دسته بندی
              نیز الزامی می باشد."
              onChange={handleChange}
              placeholder="تصویر منو"
              maxLenght="50"
            />
          </RowElement>
        </RowDiv>
        <Editor state={description} setState={setDescription} />

        <Button
          bgColor={"#4c78a9"}
          small={"200px"}
          onclick={(e) => {
            !reqLoading && handleSubmit();
          }}
          color="#fff"
        >
          {reqLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Typography size={"15px"} primary={"#fff"}>
              ثبت دسته بندی
            </Typography>
          )}
        </Button>
      </GeneratorWrapper>
    </LevelGeneratorStyle>
  );
}

const LevelGeneratorStyle = styled.div``;

const GeneratorWrapper = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

const RowDiv = styled.div`
  margin-bottom: 2rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  row-gap: 1rem;
  column-gap: 4rem;
  align-items: center;
  justify-content: flex-start;
`;

export default CatGeneratorLevel3;
